import { FiBellOff, FiBell, FiAlertCircle } from 'react-icons/fi';
import { useWebPush } from '../hooks/useWebPush';

export function BotaoAtivarPush() {
  const { status, carregando, erro, inscrever, desinscrever } = useWebPush();

  if (status === 'nao-suportado') {
    return (
      <div className="text-xs text-slate-500 italic flex items-center gap-1.5">
        <FiAlertCircle size={12} /> Seu navegador não suporta notificações push
      </div>
    );
  }
  if (status === 'negado') {
    return (
      <div className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded p-2 flex items-start gap-1.5">
        <FiAlertCircle size={12} className="flex-shrink-0 mt-0.5" />
        <span>Notificações foram <strong>bloqueadas</strong>. Para ativar, vá nas configurações do seu navegador.</span>
      </div>
    );
  }
  if (status === 'carregando') {
    return <div className="text-xs text-slate-500">Verificando notificações...</div>;
  }

  if (status === 'inscrito') {
    return (
      <button
        onClick={() => desinscrever()}
        disabled={carregando}
        className="inline-flex items-center gap-2 text-sm px-4 py-2 rounded-md border border-slate-300 bg-white text-slate-700 hover:bg-slate-50 transition disabled:opacity-50"
      >
        <FiBell size={14} className="text-emerald-600" /> Notificações ativas — toque para desativar
      </button>
    );
  }

  return (
    <div>
      <button
        onClick={() => inscrever()}
        disabled={carregando}
        className="inline-flex items-center gap-2 text-sm px-4 py-2 rounded-md bg-institutional text-white hover:bg-institutional-dark transition disabled:opacity-50"
      >
        <FiBellOff size={14} /> {carregando ? 'Ativando...' : 'Ativar notificações no celular'}
      </button>
      <p className="text-xs text-slate-500 mt-2">
        Você receberá avisos sobre o andamento dos seus protocolos sem precisar abrir o app.
      </p>
      {erro && <p className="text-xs text-red-600 mt-1">{erro}</p>}
    </div>
  );
}
